import { ReportScheduleUpdateDto } from "../../../Models/Reporting/ReportScheduleUpdateDto";
import { ReportScheduleCreateDto } from "../../../Models/Reporting/ReportScheduleCreateDto";
import { ReportScheduleReadDto } from "../../../Models/Reporting/ReportScheduleReadDto";
import { ApiRoutes } from "../../../Constants/ApiRoutingConstants";
import axios, { AxiosInstance } from "axios";
import authorizeService from "../../Identity/Utilities/AuthorizeService";
import { StandardReportRequest } from "../Components/ReportsPdfBuilder/ReportsPdfBuilderTypes";

/**
 * This service provides implementations for http calls to the api pertaining to schedule crud functionality
 */

class ReportScheduleApiService {
  axiosInstance: AxiosInstance;
  constructor() {
    //Subscribe to identity store the get token
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_REPORT_SERVICE_URL,
    });
  }

  async getAllReportSchedule(type: string): Promise<ReportScheduleReadDto> {
    let response = await this.axiosInstance({
      method: "GET",
      url: `${ApiRoutes.ReportSchedules}/${type}`,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
    });
    return response.data as ReportScheduleReadDto;
  }

  async createReportSchedule(scheduleReport: ReportScheduleCreateDto) {
    let response = await this.axiosInstance({
      method: "POST",
      url: `${ApiRoutes.ReportSchedules}`,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
      data: scheduleReport,
    });
    return response.data;
  }

  async updateReportSchedule(scheduleReport: ReportScheduleUpdateDto) {
    let response = await this.axiosInstance({
      method: "PUT",
      url: `${ApiRoutes.ReportSchedules}`,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
      data: scheduleReport,
    });
    return response.data;
  }

  async deleteReportSchedule(id: any, type: any) {
    let response = await this.axiosInstance({
      method: "DELETE",
      url: `${ApiRoutes.ReportSchedules}`,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
      data: {
        id: id,
        type: type
      },
    });
    return response.data;
  }

  /** Generate the standard PDF report; resolves with the raw PDF bytes.
   *  Pass an AbortSignal to let the caller cancel an in-flight request — aborting
   *  closes the connection, which trips HttpContext.RequestAborted on the backend. */
  async generateStandardReport(
    payload: StandardReportRequest,
    signal?: AbortSignal
  ): Promise<ArrayBuffer> {
    let response = await this.axiosInstance({
      method: "POST",
      url: ApiRoutes.ReportEndpointStandard,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
      data: payload,
      responseType: "arraybuffer",
      signal,
    });
    return response.data as ArrayBuffer;
  }

  static get instance() {
    return reportScheduleApiService;
  }

}

const reportScheduleApiService = new ReportScheduleApiService();
export default reportScheduleApiService;
